import { z } from 'zod';
import { roleSchema } from './transportExecution.availableActions.schema';

const dunsNumbersByRoleSchema = z.object({
    consignee: z.array(z.string()).optional(),
    crossdock: z.array(z.string()).optional(),
    freight_forwarder: z.array(z.string()).optional(),
});

export const getMeResponseSchema = z.object({
    roles: z.array(roleSchema),
    duns_numbers_by_role: dunsNumbersByRoleSchema,
});

export type ApiGetMeResponse = z.infer<typeof getMeResponseSchema>;
